import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Removes an address from the `}<inlineCode parentName="p">{`itemShippingAddresses`}</inlineCode>{` array. An address can only be removed if it is not referenced in any `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#itemshippingtarget"
        }}>{`ItemShippingTarget`}</a>{`.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"removeItemShippingAddress"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`addressKey`}</inlineCode>{` - String`}<br parentName="li"></br>
          {`The key of the address that is to be removed`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      